import { errors } from "../constants";
import { createErrorResult, type SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import type {
  IRideInvestigationDto,
  IRideInvestigationHistoryDto,
} from "../models";

export interface IRideInvestigationFetchOptions {
  /** Live-map debug flag — forwarded so QA/synthetic rides work like the tracking simulation. */
  debugMode?: number | null;
  abortController?: AbortController;
}

export class RideInvestigationApi {
  /** GET the assembled Deep Ride Investigation payload for a single ride. */
  static async fetchInvestigation(
    rideId: number,
    options?: IRideInvestigationFetchOptions,
  ): Promise<SimpleResult<IRideInvestigationDto> | undefined> {
    const companyId = getCompanyId();

    if (!rideId) {
      return createErrorResult<IRideInvestigationDto>(
        errors.ride.invalidRideId,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/rides/${rideId}/investigation`;
    const query = options?.debugMode
      ? { debugMode: String(options.debugMode) }
      : undefined;
    const response = await Api.get<SimpleResult<IRideInvestigationDto>>(
      requestUrl,
      query,
      options?.abortController,
    );

    return response?.data;
  }

  /** GET the ride's history (creation, audit changes, bulk jobs, supplier calls, passenger changes). */
  static async fetchHistory(
    rideId: number,
    abortController?: AbortController,
  ): Promise<SimpleResult<IRideInvestigationHistoryDto> | undefined> {
    const companyId = getCompanyId();

    if (!rideId) {
      return createErrorResult<IRideInvestigationHistoryDto>(
        errors.ride.invalidRideId,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/rides/${rideId}/investigation/history`;
    const response = await Api.get<SimpleResult<IRideInvestigationHistoryDto>>(
      requestUrl,
      undefined,
      abortController,
    );

    return response?.data;
  }
}
